//libs
import React, {Component} from "react";
import axios from "axios/index";
import connect from "react-redux/es/connect/connect";
import PropTypes from "prop-types";
//components
import Loading from "../../UI_Elements/Loading";
//other
import Config from "../../../config";
import {post, put} from '../../../actions/users';
import {isAdmin} from '../../../helpers';

class CreateUserForm extends Component {


  static propTypes = {
    /** Popup title/question */
    title: PropTypes.string,
  };

  static defaultProps = {
    title: "Skapa användare"
  };

  constructor(props) {
    super(props);

    var randomstring = Math.random().toString(36).slice(-8);
    let id, firstname, lastname, userName, role, stationId, wheelChangerId, email, mobilenumber = "";
    let passwordType = "password";

    if (typeof(props.user) !== "undefined") {
      id = props.user.id;
      firstname = props.user.firstname;
      lastname = props.user.lastname;
      userName = props.user.userName;
      stationId = props.user.stationId;
      wheelChangerId = props.user.wheelChangerId;
      role = props.user.role;
      email = props.user.email;
      mobilenumber = props.user.mobilenumber;
      randomstring = "";
      passwordType = typeof(props.user.passwordType)==="undefined" ? "password":props.user.passwordType;
    }

    this.state = {
      id: id,
      firstname: firstname,
      lastname: lastname,
      userName: userName,
      generatepassword: randomstring,
      role: role,
      stationId: stationId,
      wheelChangerId: wheelChangerId,
      email: email,
      mobilenumber: mobilenumber,
      passwordType: passwordType,
      stations: [],
      userRoles: [],
      returnStations: [],
    };
    if (stationId && id && isAdmin()) {
      this.getServiceStationsById(stationId);
    }

  }

  validateForm() {
    return this.state.email.length > 0;
  }

  componentDidMount() {
    axios.all([
      axios.get(Config.api.getDomain() + 'crud/station', Config.api.getConfig()),
      axios.get(Config.api.getDomain() + 'user/Roles', Config.api.getConfig()),
    ])
      .then(axios.spread((resOne, resTwo, resThree) => {
        const stations = resOne.data;
        const userRoles = resTwo.data;
        this.setState({stations, userRoles})
      }))
      .catch(error => {
        console.log(error);
      })
  }

  showHidePassword = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      passwordType: this.state.passwordType === 'input' ? 'password' : 'input'
    })
  }

  // Ska hämta avyttringsstationer beroende på vald station
  getServiceStations = (e) => {
    const stationId = e.target.value;
    this.getServiceStationsById(stationId);

  }

  getServiceStationsById(stationId) {
    axios.get(Config.api.getDomain() + 'station/WheelChangers/' + stationId, Config.api.getConfig())
      .then(res => {
        const returnStations = res.data;
        this.setState({returnStations});
      })
      .catch(error => {
        console.log(error);
      })
  }

  handleChange = event => {
      if (event.target.name === 'stationId'){
          this.setState({
              'wheelChangerId':null,
              [event.target.name]: event.target.value
          });
      } else {
          this.setState({
              [event.target.name]: event.target.value
          });
      }
      // Kör getServiceStations om Stationsboxen ändras
      if (event.target.name === 'stationId'){
          this.getServiceStations(event);
      }
  }

  createuserhandleSubmit = (event) => {
    event.preventDefault();


    let data = {
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      userName: this.state.userName,
      role: this.state.role,
      stationId: parseInt(this.state.stationId, 10),
      wheelChangerId: parseInt(this.state.wheelChangerId, 10),
      email: this.state.email,
      mobileNumber: this.state.mobilenumber
    }

    //on edit could be that password is empty
    //if empty then we dont update
    if (this.state.generatepassword.length > 0) {
      data.password = this.state.generatepassword
    }

    //if user id is set then we are in edit mode
    if (Number.isInteger(parseInt(this.state.id, 10))) {
      data.id = parseInt(this.state.id, 10);
      // Posta till user/Create
      this.props.put(data);
    } else {
      //no id so create user
      this.props.post(data);
    }

    if (typeof(this.props.onAccept) === "function") {
      this.props.onAccept(event);
    }

    if (typeof(this.props.onUpdatedUser) === "function") {
      this.props.onUpdatedUser(data);
    }

  }


  onCancel(e) {
    if (typeof(this.props.onCancel) === "function") {
      this.props.onCancel(e);
    }
  }

  canCreateUser(){

    if (this.state.firstname && this.state.firstname.length>0 &&
        this.state.lastname && this.state.lastname.length>0 &&
        this.state.userName && this.state.userName.length>0 &&
        this.state.stationId && this.state.stationId.length>0 &&
        this.state.wheelChangerId && this.state.wheelChangerId.length>0){
        return true;
    }
    return false;
  }

  render() {
    const {title,submitting} = this.props;

    return (
      <div className='box create-user'>
        <div className='box-inner'>
          {title &&
            <h2>{title}</h2>
          }

          <Loading show={submitting} />

          {!submitting &&

            <form onSubmit={this.createuserhandleSubmit}>
                <div className={"inputFieldWrapper"}>
                    <label htmlFor="firstname">Förnamn</label>
                    <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        placeholder="Förnamn"
                        value={this.state.firstname}
                        onChange={this.handleChange}
                        required
                    />
                </div>


                <div className={"inputFieldWrapper"}>
                    <label htmlFor="lastname">Efternamn</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        placeholder="Efternamn"
                        value={this.state.lastname}
                        onChange={this.handleChange}
                        required
                    />
                </div>


                <div className={"inputFieldWrapper"}>
                    <label htmlFor="userName">Användarnamn</label>
                    <input
                        type="text"
                        name="userName"
                        id="userName"
                        placeholder="Användarnamn"
                        value={typeof(this.state.userName)==="undefined" ? "":this.state.userName}
                        onChange={this.handleChange}
                        required
                    />
                </div>


                <div className="password-wrapper">


                    {this.state.id &&
                    <input
                        type={this.state.passwordType}
                        name="generatepassword"
                        placeholder="Genererat lösenord"
                        value={this.state.generatepassword}
                        onChange={this.handleChange}
                    />
                    }

                    {!this.state.id &&
                    <input
                        type={this.state.passwordType}
                        name="generatepassword"
                        placeholder="Genererat lösenord"
                        value={this.state.generatepassword}
                        onChange={this.handleChange}
                        required/>
                    }

                    <span
                        className="password__show"
                        onClick={this.showHidePassword}
                    >
                {this.state.passwordType === 'input' ? 'Dölj' : 'Visa'}
              </span>

                </div>

                <div className={"inputFieldWrapper"}>
                    <label htmlFor="role">Användartyp</label>
                    <select
                        name="role"
                        id="role"
                        placeholder="Användartyp"
                        onChange={this.handleChange}
                        required
                        value={this.state.role}
                    >
                        <option value="">Välj roll</option>
                        {
                            this.state.userRoles.map((role, i) => {
                                if (role.name!=="Ingen"){
                                    return <option value={role.id} key={i}>{role.name}</option>
                                }
                                return null;
                            })
                        }
                    </select>
                </div>


                <div className={"inputFieldWrapper"}>
                    <label htmlFor="stationId">Välj ägargrupp</label>
                    <select
                        name="stationId"
                        id="stationId"
                        placeholder="Välj ägargrupp"
                        onChange={this.handleChange}
                        required
                        disabled={(this.state.stationId > 0 ? true : false)}
                        value={!this.state.stationId ? "" : this.state.stationId}
                    >
                        <option value="">Välj station</option>
                        {/* Släng in foreach här */}
                        {this.state.stations.map((station, i) => {
                            return <option value={station.id} key={i}>{station.name}</option>
                        })}
                    </select>
                </div>


                <div className={"inputFieldWrapper"}>
                    <label htmlFor="wheelChangerId">Välj skiftesverkstad</label>
                    <select
                        name="wheelChangerId"
                        id="wheelChangerId"
                        placeholder="Välj skiftesverkstad"
                        onChange={this.handleChange}
                        disabled={!this.state.returnStations.length}
                        value={!this.state.wheelChangerId ? "" : this.state.wheelChangerId}
                        required
                    >
                        <option value="">Välj skiftesverkstad</option>
                        {this.state.returnStations.map((returnStation, i) => {
                            return <option value={returnStation.id} key={i}>{returnStation.name}</option>
                        })}
                    </select>
                </div>


                <p className="form-breaker"> - Valfritt - </p>

                <div className={"inputFieldWrapper"}>
                    <label htmlFor="email">E-postadress</label>
                    <input
                        type="text"
                        name="email"
                        id="email"
                        placeholder="E-postadress"
                        value={this.state.email}
                        onChange={this.handleChange}
                    />
                </div>


                <div className={"inputFieldWrapper"}>
                    <label htmlFor="mobilenumber">Mobilnummer</label>
                    <input
                        type="text"
                        name="mobilenumber"
                        id={"mobilenumber"}
                        placeholder="Mobilnummer"
                        value={!this.state.mobilenumber ? "" : this.state.mobilenumber}
                        onChange={this.handleChange}
                    />
                </div>


                {!this.state.id &&
                <input
                    type="submit"
                    name="submit"
                    className="createusersubmit form-submit"
                    value="Skapa användare"
                    disabled={!this.canCreateUser()}
                />
                }

                {Number.isInteger(this.state.id) &&
                <div className={"updateUserButtons"}>
                    <input
                        type="submit"
                        name="submit"
                        className="createusersubmit form-submit"
                        value="Uppdatera användare"
                    />
                    <button className='btn white' onClick={(e) => this.onCancel(e)}>
                        Avbryt ändringar
                    </button>
                </div>

                }
            </form>
          }
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {submitting:state.users.submitting};
};

const mapDispatchToProps = (dispatch) => {
  return {
    put: (data) => dispatch(put(data)),
    post: (data) => dispatch(post(data))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserForm)


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/CreateUserForm.js